import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { IFacilityUserSummary } from '../../core/services/facility.model';
import { LoggedInUserDeails } from '../services/login.model';
@Injectable({
  providedIn: 'root'
})
export class CreateManagerService {

  rootScopeData: RootScopeDeclare;

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService, private httpHeaderService: HttpHeadersService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  createManagerAccount(dataInput: IFacilityUserSummary): Observable<LoggedInUserDeails> {
   const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
   const result = this.httpClient.post(environment.servicePath + '/register/manager', dataInput, { headers});
   return result as Observable<LoggedInUserDeails>;

  }
}
